// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"social-media-module--wrapper--2nNRJ"};